import { useTranslation } from 'react-i18next';

import { ListContainer, ListRow, ListLabel, ListValue, EmptyState } from './index.styles';
import { resolveMetricLabel, formatTableCellValue } from '../../../../helpers';
import ProfileIcons from '../../../ProfileIcons';

type TableRowTuple = [string, TableCellValue];

export const TableRenderer = ({ data, selectedProfiles, supportedPlatforms }: DynamicModuleBuilderProps) => {
  const { t } = useTranslation('reports');

  if (!data || data.chartType !== 'SummaryTable') {
    return <EmptyState>{t('new_reports_no_posts_to_display')}</EmptyState>;
  }

  const { metrics, data: tableData } = data;

  if (!tableData || tableData.length === 0) {
    return <EmptyState>{t('new_reports_no_posts_to_display')}</EmptyState>;
  }

  const rows = tableData as unknown as TableRowTuple[];

  return (
    <>
      <ListContainer>
        {rows.map(([metricKey, rawValue], idx) => {
          // Find the metric definition matching the key from index 0
          const metricDef = metrics.find((m) => m.name === metricKey);

          return (
            <ListRow key={idx}>
              <ListLabel>{resolveMetricLabel(metricKey, t)}</ListLabel>
              <ListValue>{formatTableCellValue(rawValue, metricDef?.type, t)}</ListValue>
            </ListRow>
          );
        })}
      </ListContainer>
      <ProfileIcons
        selectedProfiles={selectedProfiles}
        supportedPlatforms={supportedPlatforms}
      />
    </>
  );
};
